import React, { memo } from "react";

import { item, RateVariationWidgetLocalization } from "../types";

interface Props {
  items: item[];
  localization: RateVariationWidgetLocalization;
}

const List: React.FC<Props> = ({ items, localization }) => {
  if (!items) return null;

  return (
    <table className="table-rates--double table-rates mb-8 sm:mb-12">
      <thead>
        <tr>
          <th className="pb-4" aria-label="empty" />
          <th className="pb-4">{localization.Buying}</th>
          <th className="pb-4">{localization.Selling}</th>
        </tr>
      </thead>

      <tbody className="table__body">
        {items.map((data) => (
          <tr key={data.id}>
            <td className="table__title border-b border-red-corporate pb-4">
              <strong className="sm:mr-4">{data.currencyPair}</strong>
              <span className="text-2xs">{data.cardAssociation}</span>
            </td>
            <td data-title={localization.Buying}>{data.buyingMargin}</td>
            <td data-title={localization.Selling}>{data.sellingMargin}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default memo(List);
